import { BANNER_COOKIE_PREFIX } from "@/constants/selectors";

export default function getBannerCookieName(name: string) {
  name = name.replace(/[\s]/g, "-");
  name = name.replace(/[^a-zA-Z\d]/g, "");

  return `${BANNER_COOKIE_PREFIX}${name}`;
}
